import { createRouter, createWebHistory } from 'vue-router';

import { allRoutes } from './constants';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: allRoutes,
});

router.onError((error) => {
  if (error.message.includes('Failed to fetch dynamically imported module')) {
    console.warn('A new version released. Need to reload the page to apply changes.');
    window.location.reload();
  }
});

export default router;
